import OrderDetailsNew from "../../orders/newOrderDetails";
import "./BillDrawer.css";

const BillDrawer = ({ open, onClose, orderId, orderDetails }) => {
  return (
    <>
      {open && <div className="od-drawer-overlay" onClick={onClose} aria-hidden="true" />}
      <aside
        className={`od-bill-drawer${open ? " od-bill-drawer--open" : ""}`}
        aria-label="Bill drawer"
        role="dialog"
        aria-modal="true"
      >
        {/* Header */}
        <div className="od-drawer-header">
          <div className="od-drawer-header-left">
            <p className="od-drawer-label" data-testid="text-order-drawer-label">
              Order ID:
            </p>
            <p className="od-drawer-id" data-testid="text-order-drawer-id">
              {orderDetails?.baseOrderResponse?.orderId || orderId}
            </p>
            <span className="od-badge od-badge--delivered" data-testid="status-order-drawer-state">
              {orderDetails?.baseOrderResponse?.orderStatus || "DELIVERED"}
            </span>
          </div>
          <button
            className="od-drawer-close-btn"
            onClick={onClose}
            data-testid="button-close-order-drawer"
            aria-label="Close bill drawer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>

        {/* Scrollable bill content */}
        <div className="od-drawer-scroll">
          <section className="bill-layout-template-section">
            <OrderDetailsNew orderId={orderId} />
          </section>
        </div>
      </aside>
    </>
  );
};

export default BillDrawer;
